import React, { useReducer, useContext } from "react";
import { topicReducer as reducer } from "../reducers/topicReducer";
import { topicActions as actions } from "../actions/topicActions";

const initialValue = {
  topics: null,
  showModal: false,
};

const topicContext = React.createContext();

const TopicContext = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialValue);

  return (
    <topicContext.Provider value={{ state, dispatch, actions }}>
      {children}
    </topicContext.Provider>
  );
};

export const useTopicContext = () => React.useContext(topicContext);
export default TopicContext;
